import Resource from './Resource';

export default class Accounts extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !routeParams.settings ? 'accounts' : `accounts/${routeParams.settings}`;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}
}
